import { Organization } from "./organizations";
import { BaseUser } from "./user";
import { Workspace } from "./workspaces";
import { WorkspaceInvite } from "./workspace-invite";

import { OrganizationMemberLifecycleStatus } from "@/enums/organization-member-lifecycle-status";
import { OrganizationRole } from "@/types/organization-roles";

export { OrganizationMemberLifecycleStatus };

export interface BaseOrganizationMember {
  id: number;
  organization_id: number;
  user_id: number;
  created_at: string;
  name: string;
  organization_role: OrganizationRole;
  is_owner: boolean;
  default_workspace_id?: number;
}

export interface OrganizationMember extends BaseOrganizationMember {
  organization: Organization;
  user: BaseUser;
  workspaces: Workspace[];
}

export interface OrganizationMembersTableWorkspaceInfo {
  name: string;
  is_admin: boolean;
  roles: string[];
}

export interface OrganizationMembersMemberRow {
  id: string;
  status: Exclude<OrganizationMemberLifecycleStatus, OrganizationMemberLifecycleStatus.PENDING>;
  email: string;
  organization_id: number;
  organization_member_id: number;
  user_id: number;
  created_at: string;
  updated_at: string;
  deactivated_at?: string | null;
  organization_role: OrganizationRole;
  is_owner: boolean;
  is_break_glass: boolean;
  default_workspace_id?: number;
  organization?: Organization;
  user: BaseUser;
  workspaces: OrganizationMembersTableWorkspaceInfo[];
}

/** @deprecated Use OrganizationMembersMemberRow */
export type OrganizationMembersActiveRow = OrganizationMembersMemberRow;

export interface OrganizationMembersPendingRow {
  id: string;
  status: OrganizationMemberLifecycleStatus.PENDING;
  email: string;
  organization_id: number;
  invitee_email: string;
  invites: WorkspaceInvite[];
  created_at?: string;
  updated_at?: string;
  workspaces: OrganizationMembersTableWorkspaceInfo[];
}

export type OrganizationMembersTableRow =
  | OrganizationMembersMemberRow
  | OrganizationMembersPendingRow;

export const isOrganizationMembersMemberRow = (
  item: OrganizationMembersTableRow,
): item is OrganizationMembersMemberRow =>
  item.status !== OrganizationMemberLifecycleStatus.PENDING;

/** @deprecated Use isOrganizationMembersMemberRow */
export const isOrganizationMembersActiveRow = isOrganizationMembersMemberRow;

export const isOrganizationMembersPendingRow = (
  item: OrganizationMembersTableRow,
): item is OrganizationMembersPendingRow =>
  item.status === OrganizationMemberLifecycleStatus.PENDING;
